export default function setTemplateType(templates) {
    // Adds (User-Defined) / (Standard) to end of template name
    templates.forEach(template => {
        template.userDefined ? template.name += ' (User-Defined)' : template.name += ' (Standard)'
    });
    return templates;
}